if (!String.prototype.format) {
    String.prototype.format = function () {
        const args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
                ? args[number].toString()
                : match;
        });
    };
}
if (!String.prototype.toTitleCase) {
    String.prototype.toTitleCase = function () {
        return (!this || !this.length)
            ? this
            : this[0].toUpperCase() + this.substr(1);
    };
}
if (!String.prototype.toJson) {
    String.prototype.toJson = function () {
        try {
            let json = JSON.parse(this);
            return json;
        }
        catch (e) {
            return null;
        }
    };
}
